
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
import { putMenuList, updMenuList } from "@/api/backstage";
import { useStore } from "vuex";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;
import { getParentMenuList,getMenuInfo } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增菜单",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg 
  },
 
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    const store = useStore();
    let isEdit = false;
    let show = opt.open;
 

    const close = () => {
      contex.emit("close", false);
    };

    const dataMap: any = reactive({
      index:'',
      filurl:localStorage.getItem('fileUrel'),
      selectValue: "",
      menuList: [],
      menuType: "",
      menuClass: "",
      ruleForm: {
        menuName: "",
        menuType: "",
        menuClassfier: "",
        menuCode: "",
        grade: 1,
        englishName: "",
        icon: "",
        parent: "",
        parentId: "",
        path: "",
        remark: "",
        sortNum: "",
        files:[],
      },
      rules: {
        menuName: [
          { required: true, message: "请输入菜单名", trigger: "blur" },
        ],
        menuClassfier: [
          { required: true, message: "请选择菜单所属", trigger: "blur" },
        ],
        menuCode: [
          { required: true, message: "请输入菜单名编码", trigger: "blur" },
        ],
        menuType: [
          { required: true, message: "请选择菜单类型", trigger: "blur" },
        ],
        grade: [{ required: true, message: "请输入菜单层级", trigger: "blur" }],
      },
      

      async getMenuType() {
        dataMap.menuType = {};
        const menus = await getEnum("MENU_TYPE");
        for (const item of menus.data) {
          dataMap.menuType[item.enumKey] = item;
        }
      },
      async getMenuClass() {
        dataMap.menuClass = {};
        const menus = await getEnum("MENU_CLASSFIER");
        for (const item of menus.data) {
          dataMap.menuClass[item.enumKey] = item;
        }
      },
      async getMenuList() {
        const res = await getParentMenuList();
        dataMap.menuList = res.data;
      },
 
      
      async putMenuList() {
        const res = await putMenuList(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      async updMenuList() {
        const res = await updMenuList(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });
    
    const getIndex = (index: any) => {
      dataMap.index = index;
    };
  

  const addOther = (index: any) => {
      dataMap.ruleForm.files.push({ title: "", fileName: "", description: "", });
    };

    const change = (val: any) => {
      dataMap.ruleForm.parentId = val.id;
      dataMap.ruleForm.parent = val.name;
    };
    if (opt.row){
      isEdit = true;
      getMenuInfo(opt.row.id).then((res: any)=>{
         dataMap.ruleForm = res.data;
      });
 
 

    }
   const removeList = (index: any) => {
      dataMap.ruleForm.files.splice(index, 1);
    };
    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
         isEdit ? dataMap.updMenuList() : dataMap.putMenuList();
          form.resetFields();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
     const onSuccess = (val: any) => {
     dataMap.ruleForm.files[dataMap.index].fileName = val.fileName;
    };
    onMounted(() => {
      if(opt.row.icon) dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") + opt.row.icon;
      dataMap.getMenuList();
      dataMap.getMenuType();
      dataMap.getMenuClass();
    });
    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      removeList,
      addOther,
      getIndex,
      close,
      onSuccess,
      change,
      ...toRefs(dataMap),
    };
  },
});
